import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import PackagesContainer from "../containers/packages";
import Footer from "../layouts/footer";
import Header from "../layouts/header/index";
import Layout from "../layouts/index";

const Packages = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="Nischay || Package" />
                <div className="wrapper home-default-wrapper">
                    <Header classOption="hb-border" />
                    <div className="main-content">
                        <PackagesContainer />
                    </div>
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default Packages;
